/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SolicitacoesPendentesInformarParecerAliases {
  AUTOCOMPLETE_SITUACAO = 'autocomplete-situacao',
  FETCH_SITUACAO = 'fetch-situacao',
  FIELD_APROVADA = 'field-aprovada',
  FIELD_ITEM = 'field-item',
  FIELD_PARECER = 'field-parecer',
  FIELD_QT_SOLICITADA = 'field-qtSolicitada',
  FIELD_SITUACAO = 'field-situacao',
  FORM_INFORMAR_PARECER = 'form-informar-parecer',
  INPUT_APROVADA = 'input-aprovada',
  MAPPER_SITUACAO = 'mapper-situacao',
  PANEL_SOLICITACOES_PENDENTES_INFORMAR_PARECER = 'panel-solicitacoes-pendentes-informar-parecer',
  TEXT_AREA_PARECER = 'text-area-parecer',
  TEXT_ITEM = 'text-item',
  TEXT_QT_SOLICITADA = 'text-qtSolicitada',
  TEXT_SITUACAO = 'text-situacao',
}
export { SolicitacoesPendentesInformarParecerAliases };
